import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// libraries
import $ from 'jquery';

import GenericFormPopUp from '../../generic_components/GenericFormPopUp';

import * as CONSTANTS from '../../constants';
import * as CONFIG from '../../config';
import * as UTILS from '../../utils/utilFunctions';
import TEXT_GENERAL from '../../text';

// import TEXT from './staticContent/text';
// import { staticResources } from './staticContent/ProjectDetailsCreatePopUpDropDowns';

class CandidateJobCreatePopUpContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.form = this.generateFormFields();

    // error handling required for API calls
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  updateAPICall = updatedData => {
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    const url = CONSTANTS.addCandidateSubSchemaEntryURL;

    const payload = {
      candidateId: this.props.candidateId,
      subSchemaName: 'jobs',
      subSchemaData: updatedData
    };
    if (Object.keys(updatedData).length > 0) {
      console.log(`API ${url} request`, payload);
      $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: { 'x-auth': tokenFromLocalStorage },
        data: JSON.stringify(payload),
        timeout: CONFIG.ajaxTimeout
      })
        .done((responseBody, status) => {
          console.log(`API /${url} response`, responseBody, status);
          this.props.handleSnackbarOpen(
            TEXT_GENERAL.snackBarTexts.createSuccess
          );
          this.props.refreshCandidate();
          this.props.handleClose();
        })
        .fail(err => {
          this.errorHandling(err, url);
        });
    } else {
      this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.noCreate);
    }
  };

  generateFormFields() {
    // console.log('DEBUG contactDate', this.props.data.contactDate);
    const forms = {
      formFields: {
        jobText: {
          value: '',
          label: 'Titel',
          customClass: 'col-12 mb-2',
          required: 'true',
          validator: 'isText'
        },
        company: {
          value: '',
          label: 'Firma',
          customClass: 'col-12 mb-2',
          required: 'true',
          validator: 'isText'
        },
        description: {
          value: '',
          label: 'Beschreibung',
          customClass: 'col-12 mb-2',
          additionalProps: { multiline: true }
          // required: 'true',
          // validator: 'isText'
        },
        fromDate: {
          value: '',
          type: 'date',
          label: 'Von',
          required: true
        },
        tillDate: {
          value: '',
          type: 'date',
          label: 'Bis'
        }
      }
    };

    return forms;
  }

  render() {
    this.form = this.generateFormFields();
    return (
      <GenericFormPopUp
        open={this.props.open}
        headlineText="Berufserfahrung hinzufügen"
        // key="hallo"
        genericFormProps={{
          formFields: this.form.formFields,
          handleSubmit: this.updateAPICall,
          // initialData: this.props.data,
          handleClose: this.props.handleClose

          // buttonCancelText: TEXT.projectDetailsCreatePopUp.buttons.cancel,
          // buttonSaveText: TEXT.projectDetailsCreatePopUp.buttons.save
        }}
      />
    );
  }
}
CandidateJobCreatePopUpContainer.defaultProps = {
  // isCreate: false,
  // data: {}
};

CandidateJobCreatePopUpContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,

  // data
  candidateId: PropTypes.string.isRequired,
  // snackBar
  handleSnackbarOpen: PropTypes.func.isRequired,
  refreshCandidate: PropTypes.func.isRequired
};

export default CandidateJobCreatePopUpContainer;
